import React from 'react';
import parse from 'html-react-parser';

interface TipItem {
  title: string;
  content: string;
}

interface Props {
  item: TipItem;
}

const TipsAndTricksItem = ({ item }: Props) => (
  <div className="bg-main-light mb-4 rounded-lg py-4 px-4 lg:bg-none lg:mt-4 lg:rounded-none lg:p-0">
    <p className="text-lg font-bold">{item.title}</p>
    <div className="mt-1 text-sm lg:text-base">{parse(item.content)}</div>
  </div>
);

export default TipsAndTricksItem;
